import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 0C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0H6ZM16.25 7.37475L9.32843 14.375L5 9.99938L6.73039 8.24963L9.32843 10.8755L14.5196 5.625L16.25 7.37475Z",
		fill: "#4F49BA"
	})
});
export default SvgCheckboxChecked;
